import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { SelectOption, TemplateSelectComponent } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idi",
  imports: [TemplateSelectComponent],
  templateUrl: "./prefix-idi.component.html",
  styleUrl: "./prefix-idi.component.less",
})
export class PrefixIdiComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idi"];
  }
}
